import { useState } from 'react';

import { MainContainer, SpanTag } from './DropDownStyle';

const DropDownModal = (props: {
  intervalData: string[];
  handleOptionClick: (item: string, index: number) => void;
  positionDownwards: boolean;
  selectedDropDownIndex?: number;
}) => {
  const {
    intervalData,
    handleOptionClick,
    positionDownwards,
    selectedDropDownIndex
  } = props;
  const [selectedItemIndex, setSelectedItemIndex] = useState<number>(
    selectedDropDownIndex || 0
  );

  const handleClickHandler = (event: React.MouseEvent<HTMLSpanElement>) => {
    const spanElement = event.target as HTMLSpanElement;
    const clickData = spanElement.dataset.customInfo;
    if (clickData?.length) {
      const [currentSelectedItem, currentSelectedItemIndex] = clickData?.split(
        ','
      ) as string[];
      const parseCurrentSelectedItemIndex = parseInt(currentSelectedItemIndex);
      if (selectedItemIndex !== parseCurrentSelectedItemIndex) {
        setSelectedItemIndex(parseCurrentSelectedItemIndex);
        handleOptionClick(currentSelectedItem, parseCurrentSelectedItemIndex);
      }
    }
  };

  return (
    <MainContainer
      data-testid="dropDown-item-container"
      positionDownwards={positionDownwards}>
      {intervalData?.map((item: string, index: number) => {
        return (
          <SpanTag
            data-testid={`dropDown-item-${index + 1}`}
            data-custom-info={[item, index]}
            onClick={handleClickHandler}
            isSelected={index === selectedItemIndex}
            key={index}>
            {item}
          </SpanTag>
        );
      })}
    </MainContainer>
  );
};

export default DropDownModal;
